import React, { useEffect, useState, useCallback } from "react";
import { Button, Grid, IconButton } from "@mui/material";
import jwt_decode from "jwt-decode";
import ButtonLogOut from "../common/buttonLogOut";
import { useTranslation } from "react-i18next";
import logo from "../../assets/common/logo.svg";
import MenuIcon from "@mui/icons-material/Menu";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { useNavigate } from "react-router-dom";
import NotificationIcon from "./notificationIcon";

const TopBar = ({ setShowMenu, showMenu }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  /**
   * Use State
   */
  const [isDesktop, setDesktop] = useState(window.innerWidth > 400);

  /**
   * Actualiza el tamaño de pantalla
   * @returns
   */
  const updateMedia = () => {
    setDesktop(window.innerWidth > 400);
  };

  /**
   * useEffect to update the state of isDesktop based on the size of the browser window
   */
  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });

  /** Efecto para escuchar cambios de tamaño de ventana al montar. */
  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  }, []);

  /** Navega al centro de ayuda según el rol del usuario. */
  const handleNavigateHelpCenter = useCallback(() => {
    const jwtTokenInfo = localStorage.getItem("infoToken");
    if (jwtTokenInfo) {
      const { "custom:Role": userRole } = jwt_decode(jwtTokenInfo);
      navigate(`/${userRole}/helpCenter`);
    }
  }, [navigate]);

  return (
    <Grid container className="navbar">
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item xs={6} container direction="row" alignItems="center">
          {!showMenu && (
            <Grid item xs={2}>
              <IconButton onClick={() => setShowMenu(true)} className="hamburguer-menu">
                <MenuIcon sx={{ fontSize: 22, color: "black" }} />
              </IconButton>
            </Grid>
          )}
          <Grid item xs={showMenu ? 12 : 10}>
            <img src={logo} alt="Logo Prescriptiva" className="navbar__logo-top" />
          </Grid>
        </Grid>

        <Grid
          item
          xs={isDesktop ? 6 : 5}
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          spacing={3}
        >
          {isDesktop && (
            <Grid item xl={2.2} lg={3} sm={4}>
              <Button
                className="btn__filled__light-blue step-3"
                sx={{
                  borderRadius: "8px",
                  minHeight: "39px",
                  minWidth: "140px",
                }}
                startIcon={<SupportAgentIcon />}
                onClick={handleNavigateHelpCenter}
              >
                {t("App.helpCenter.helpButton")}
              </Button>
            </Grid>
          )}
          {/* Icono de notificaciones visible en todas las resoluciones */}
          <Grid
            item
            xs={3}
            sm={1}
            sx={{
              ml: { xs: 0, sm: 1 }, // Sin margen a la izquierda en xs
              mr: { xs: 0, sm: 1 }, // Sin margen a la derecha en xs
            }}
          >
            <IconButton>
              <NotificationIcon />
            </IconButton>
          </Grid>
          <Grid item xs={8} sm={6} md={5.7} lg={4.85} xl={4.4} className="step-1">
            <ButtonLogOut />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

/** Componente TopBar para la barra superior. */
export default TopBar;